import script from "./SecureWallpaperImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SecureWallpaperImage.vue?vue&type=script&setup=true&lang=ts"

import "./SecureWallpaperImage.vue?vue&type=style&index=0&id=3b32317c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b32317c"]])

export default __exports__